<template>
    <div class="ah-project-card">
        <div class="card-header">
            <span class="title">
                <div class="poo">#{{ project.poo }}</div>
                <div class="project-name">
                    <span class="category-label">{{ project.pjcaT_NAM }}</span>
                    <span v-if="project.customnumber">({{ project.customnumber }}) </span>
                    <span class="name-text">{{ project.nam }}</span>
                </div>
            </span>
            <span class="actions">
                <el-button size="mini" @click="handleDetailBtnClick" v-if="showDetailBtn">檢視</el-button>
                <el-button size="mini" @click="handleRemoveBtnClick" v-if="showRemoveBtn">移除</el-button>
            </span>
        </div>
        <div class="card-body">
            <div class="infos" v-if="showInfos">
                <ul class="info-list">
                    <li>
                        <div class="label">專案經理：</div>
                        <div class="value">{{ project.stF_SNO_NAM }}</div>
                    </li>
                    <li>
                        <div class="label">客戶：</div>
                        <div class="value">{{ project.vdR_NAM }}</div>
                    </li>
                    <li>
                        <div class="label">總金額：</div>
                        <div class="value"><Money :v="project.amt" /> {{ project.cny }}</div>
                    </li>
                </ul>
            </div>
            <div class="tab">
                <div class="item">分期</div>
            </div>
            <div class="installments">
                <el-table :data="project.installments" class="installment-table" size="small" empty-text="沒有分期項目">
                    <el-table-column width="35" v-if="showInstallmentCheckbox">
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.checked" @change="handleInstallmentCheckChange" :disabled="isInstallmentDisabled(scope.row)"></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column prop="stG_NO" label="期數" width="85">
                        <template slot-scope="scope">
                            <div>第 {{ scope.row.stG_NO }} 期</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="sts" label="發票狀態" width="85" v-if="showInstallmentStatus">
                        <template slot-scope="scope">
                            <invoice-status-label v-if="scope.row.invoiceIOO" :status-num="scope.row.status" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="sts" label="發票單號" v-if="showInstallmentIoo">
                        <template slot-scope="scope">
                            <span class="invoice-ioo-btn" v-if="scope.row.invoiceIOO" @click="handleIooClick(scope.row.invoiceNo)">{{ scope.row.invoiceIOO }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="foo" label="發票號碼">
                        <template slot-scope="scope">
                            <div>
                                <span>{{ scope.row.invoiceFOO }}</span>
                                <span v-if="scope.row.foO_DIS_CNL" class="foo-dis-label">(發票已作廢)</span>
                                <span v-if="!scope.row.foO_DIS_CNL && scope.row.foO_DIS_AMT" class="foo-dis-label">(折讓：<Money :v="scope.row.foO_DIS_AMT" />)</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="amt" label="金額" align="right">
                        <template slot-scope="scope">
                            <Money :v="scope.row.amt" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="cny" label="幣別" align=""> </el-table-column>
                </el-table>
            </div>
        </div>
        <InvoiceDetailDialog ref="detailDialog" @close="handleInvoiceDetailDialogClose" :visible="invoiceDetailDialog.visible" :sno="invoiceDetailDialog.sno" />
    </div>
</template>
<script>
import InvoiceStatusLabel from '@/components/dashboard/Invoice/InvoiceStatusLabel.vue';

export default {
    name: 'ah-project-card',
    components: {
        InvoiceStatusLabel,
        InvoiceDetailDialog: () => import('@/components/dashboard/Invoice/InvoiceDetailDialog.vue'),
    },
    props: {
        project: {
            type: Object,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        showDetailBtn: {
            type: Boolean,
            default: false,
        },
        showRemoveBtn: {
            type: Boolean,
            default: true,
        },
        showInfos: {
            type: Boolean,
            default: true,
        },
        showInstallmentCheckbox: {
            type: Boolean,
            default: true,
        },
        showInstallmentStatus: {
            type: Boolean,
            default: true,
        },
        showInstallmentIoo: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            invoiceDetailDialog: {
                visible: false,
                sno: null,
            },
        };
    },
    methods: {
        handleInstallmentCheckChange() {
            this.$emit('installmemtCheckChanged');
        },
        handleIooClick(invoiceSno) {
            this.$emit('invoiceClick', invoiceSno);
            this.invoiceDetailDialog.sno = invoiceSno;
            this.invoiceDetailDialog.visible = true;
        },
        handleDetailBtnClick() {
            this.$emit('detail', this.project.sno);
        },
        handleRemoveBtnClick() {
            this.$emit('remove', this.project.sno);
        },
        handleInvoiceDetailDialogClose() {
            this.invoiceDetailDialog.visible = false;
            this.invoiceDetailDialog.sno = null;
        },

        isInstallmentDisabled(item) {
            // if (!item.invoiceIOO) return false;
            return !!item.invoiceIOO;
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.ah-project-card {
    line-height: 100%;
    border: 2px solid #eee;
    border-radius: 12px;
    box-shadow: 1px 3px 10px rgba(0, 0, 0, 0.05);
    color: #444;
    margin-bottom: 15px;

    .project-name {
        > .category-label {
            font-size: 10pt;
            background-color: #eee;
            padding: 5px 7px;
            border-radius: 4px;
            margin-right: 7px;
        }

        > .name-text {
            font-size: 11pt;
            font-weight: bold;
        }
    }

    .card-header {
        display: table;
        width: 100%;

        > .title {
            display: table-cell;
            vertical-align: top;
            padding: 20px 30px 30px 30px;
            font-size: 10pt;

            > .poo {
                font-size: 9pt;
                opacity: 0.5;
                margin-bottom: 10px;
            }
        }

        > .actions {
            display: table-cell;
            vertical-align: top;
            text-align: right;
            padding: 20px 30px 0 30px;
        }
    }

    .card-body {
        padding: 0px 30px 30px 30px;

        > .infos {
            margin: 0 0 20px 0;

            > .info-list {
                list-style: none;
                display: table;
                line-height: 160%;

                > li {
                    display: table-row;

                    > .label {
                        display: table-cell;
                        vertical-align: top;
                        width: 110px;
                    }

                    > .value {
                        display: table-cell;
                        vertical-align: top;
                    }
                }
            }
        }
    }

    .tab {
        position: relative;
        border-bottom: 2px solid #eee;
        margin-bottom: 5px;

        .item {
            position: relative;
            top: 2px;
            display: inline-block;
            padding: 12px 20px;
            border-bottom: 2px solid $main-color;
            color: $main-color;
            font-size: 10pt;
            font-weight: bold;
        }
    }

    .installment-table {
        .el-table__header {
            th {
                line-height: 15px;
            }
        }
    }

    .invoice-ioo-btn {
        cursor: pointer;
        color: #666;

        &:hover {
            color: #000;
        }
    }
    .foo-dis-label {
        margin-left: 12px;
        color: red;
    }
}
</style>
